export default function EarningsHeader() {
    return (
      <div className="er-header">
        <h1 className="er-title">Earnings</h1>
      </div>
    );
  }
  